import { Component } from "@angular/core";
import { UserService } from "./shared/services/user.service";
import { Router, ActivatedRoute, NavigationStart } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "my-app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  user;
  routeUrl;
  version = "1.0.2";

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {
    translate.addLangs(["en", "fr"]);
    translate.setDefaultLang("en");

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");

    this.userService.auth.user.subscribe(user => {
      this.user = user;
    });

    this.router.events.subscribe(value => {
      if (value instanceof NavigationStart) {
        this.routeUrl = value.url;
      }
    });
  }

  _login(e) {
    this.userService.login(e);
  }

  _logout() {
    this.userService.logout();
  }

  disableLogin() {
    return this.router.url.includes("mc/play");
  }

  showBanner(): boolean {
    return !this.router.url.startsWith("/mc/play");
  }

  isRouterOutletMaxWidth(): boolean {
    return this.routeUrl ? !this.routeUrl.startsWith("/mc/play") : false;
  }

  useTranslate(lang) {
    console.log("useTranslate", lang);
    this.translate.use(lang);
  }
}
